// Product action
export const ALL_PRODUCTS = "ALL_PRODUCTS"
export const ALL_CATEGORIES = "ALL_CATEGORIES"
export const HOME_PRODUCTS = "HOME_PRODUCTS"
export const PRODUCT_DETAILS = "PRODUCT_DETAILS"

// Cart
export const ADD_TO_CART = "ADD_TO_CART"
export const CART = "CART"

// wishlist
export const WISHLIST = "WISHLIST"
export const GET_WISHLIST = "GET_WISHLIST"

// filter
export const FILTERED = "FILTERED"
export const SEARCH = "SEARCH"
export const PROMOCODE = "PROMOCODE"


export const PRODUCT_DETAILS_NULL = "PRODUCT_DETAILS_NULL"
export const NOTIFICATION = "NOTIFICATION"
export const PRODUCTS = "PRODUCTS"


//Advertisement banner
export const ADVERTISEMENT_BANNER = "ADVERTISEMENT_BANNER"

//offer actions
export const LAST_MIN_DEAL = "LAST_MIN_DEAL"
export const DEAL_OF_DAY = "DEAL_OF_DAY"
export const OFFERS = "OFFERS"
export const VISITOR = "VISITOR"

// Auth actions
export const OTP_SEND = "OTP_SEND"
export const OTP_VERIFY = "OTP_VERIFY"
export const PROFILE_UPDATED = "PROFILE_UPDATED"
export const SOCIAL_LOGIN = "SOCIAL_LOGIN"
export const CONTACT_US = "CONTACT_US"

// checkout
export const ALL_ADDRESS = "ALL_ADDRESS"
export const ADD_ADDRESS = "ADD_ADDRESS"
export const UPDATE_ADDRESS = "UPDATE_ADDRESS"
export const DELETE_ADDRESS = "DELETE_ADDRESS"
export const PROMO_LIST = "PROMO_LIST"

// order
export const ORDER_CONFIRM = "ORDER_CONFIRM"
export const ORDERS = "ORDERS"
export const SHIPPING = "SHIPPING"